/** Labels for CRM settings fields */

export const IDLE_THRESHOLD_FIELDS = [
  { key: 'idle_days_new', label: 'New', status: 'new' },
  { key: 'idle_days_contacted', label: 'Contacted', status: 'contacted' },
  { key: 'idle_days_intake_sent', label: 'Intake sent', status: 'intake_sent' },
  { key: 'idle_days_intake_received', label: 'Intake received', status: 'intake_received' },
  { key: 'idle_days_scheduling', label: 'Scheduling', status: 'scheduling' },
]

export const CHANNEL_LABELS = {
  email: 'Email',
  sms: 'SMS',
  whatsapp: 'WhatsApp',
  ligacao: 'Phone call',
}

export const CLIENT_FOLLOWUP_THRESHOLD_FIELDS = [
  { key: 'client_followup_days_contacted', label: 'Contacted' },
  { key: 'client_followup_days_intake_sent', label: 'Intake sent' },
]
